var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.1785L19 20.0606M10.5 21.1195C11.7476 21.1195 12.9829 20.8593 14.1355 20.3538C15.2881 19.8482 16.3354 19.1072 17.2175 18.1731C18.0997 17.239 18.7994 16.13 19.2769 14.9095C19.7543 13.689 20 12.3808 20 11.0598C20 9.73871 19.7543 8.43057 19.2769 7.21007C18.7994 5.98956 18.0997 4.88058 17.2175 3.94644C16.3354 3.0123 15.2881 2.27131 14.1355 1.76575C12.9829 1.2602 11.7476 1 10.5 1C7.98044 1 5.56408 2.05987 3.78249 3.94644C2.00089 5.83301 1 8.39176 1 11.0598C1 13.7278 2.00089 16.2865 3.78249 18.1731C5.56408 20.0597 7.98044 21.1195 10.5 21.1195Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.edad797629c6677a74f6d9c74c2da3cd.svg";
export { ForwardRef as ReactComponent };